var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('QueryFrame',{attrs:{"disablePage":true,"add-text":_vm.handlePermission('insuranceCardPwdUpdate') ? '修改卡密码' : ''},on:{"addNew":_vm.handleCardPwd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }